const WritingStyles = {
  DEFAULT: "default",
  CONCISE: "concise",
  FORMAL: "formal",
  INFORMAL: "informal",
}

module.exports = {
  WritingStyles,
};